import {Box, Flex, P, Span} from 'exsportia-components'
import {DateTime} from 'luxon'
import {FC} from 'react'

import {CycleToShow} from '../../../api/subscription-bookings/helpers'
import {SubscriptionBooking, SubscriptionBookingStatusesEnum} from '../../../api/subscription-bookings/types'
import {TranslatorScope} from '../../../locale/types'
import {CurrenciesEnum} from '../../../types/currencies'
import {ExsportiaIcon} from '../../../ui/components/exsportia-icon/exsportia-icon'
import {useLocale} from '../../../utils/i18n'

type Props = {
  rolling: boolean,
  cyclesLength: number
  subStatus: SubscriptionBooking['subStatus']
  currency: CurrenciesEnum
  cycle: CycleToShow
}

const styleConfigBySubStatus: {
  AWAITING_PAYMENT: {
    color: 'notify',
    label: TranslatorScope,
  },
  PAYMENT_FAILED: {
    color: 'error',
    label: TranslatorScope,
  },
} = {
  AWAITING_PAYMENT: {
    color: 'notify',
    label: 'awaiting_payment',
  },
  PAYMENT_FAILED: {
    color: 'error',
    label: 'payment_failed',
  },
}


export const UnpaidInvoice: FC<Props> = ({
  rolling,
  subStatus,
  cyclesLength,
  currency,
  cycle: {price, startDate, elIndex, isFirstUnpaid}
}) => {
  const {l} = useLocale()
  const {label, color} = styleConfigBySubStatus[
    (isFirstUnpaid && subStatus === SubscriptionBookingStatusesEnum.PAYMENT_FAILED)
      ? SubscriptionBookingStatusesEnum.PAYMENT_FAILED
      : SubscriptionBookingStatusesEnum.AWAITING_PAYMENT
    ]

  const startDateString = DateTime.fromMillis(startDate).toLocaleString(DateTime.DATE_MED)
  return (
    <Flex
      flex={1}
      height={'40px'}
      cursor={'default'}
      flexDirection={'row'}
      alignItems={'center'}
    >
      <Box mr={'12px'}>
        <ExsportiaIcon icon={'warning'} color={color}/>
      </Box>
      <Flex
        flex={1}
        flexDirection={'row'}
        alignItems={'center'}
      >
        <P variant={'footnote'}>
          <Span>
            {startDateString}
          </Span>
          <Span>
            {` · ${elIndex}${rolling ? '' : ` / ${cyclesLength}`} · `}
          </Span>
          <Span
            color={color}
          >
            {l(label, {caseAction: 'capitalize'})}
          </Span>
        </P>
      </Flex>
      <Span
        pl={'8'}
        variant={'body'}
        color={color}
      >
        {l(`${currency}_symbolic` as TranslatorScope, {value: price})}
      </Span>
    </Flex>
  )
}

/*
<Pressable
      disabled={!transactions?.[0].transactionId || !transactions?.[0]?.docType}
      onPress={handleOpenInvoicePdf}
    >

    </Pressable>
* */